import { IDataProducts } from 'common/contracts';

export const productsData: IDataProducts[] = [
  {
    id: '6cd0fd3f6aea4e33b9308ffb121d0690',
    model: '116-5861-0.18.2801 116-5861-0.18.2803',
    title: 'Autro Sense',
    link: 'http://product.autronicafire.com/products/fire-and-gas-detection-systems/detectors-for-special-requirements/aspirating-hssd/autrosense-series/autrosense-cascade/',
    roomRoute: 'data-hall',
    facilityRoute: 'data-center',
    pos: { top: 65, left: 37, unit: '%' },
    content: [
      'AutroSense Cascade is a scalable aspirating smoke detection solution that makes installation easier, maintenance quicker, and takes applications further than traditional air sampling detectors'
    ],
    productImage: 'autro-sense.png',
    featureList: [
      'Eight detector modules controlled via one display ',
      'Easy pipe connection',
      'two-way mounting design',
      'Easy screen overview'
    ]
  },
  {
    id: '00d0e608c34943e19d5f67eaf0516d04',
    model: '116-5861-0.18.2801 116-5861-0.18.2803',
    title: 'Autro Sense',
    link: 'http://product.autronicafire.com/products/fire-and-gas-detection-systems/detectors-for-special-requirements/aspirating-hssd/autrosense-series/autrosense-cascade/',
    roomRoute: 'data-hall',
    facilityRoute: 'e-house',
    pos: { top: 72, left: 34, unit: '%' },
    content: [
      'AutroSense Cascade is a scalable aspirating smoke detection solution that makes installation easier, maintenance quicker, and takes applications further than traditional air sampling detectors'
    ],
    productImage: 'autro-sense.png',
    featureList: [
      'Eight detector modules controlled via one display ',
      'Easy pipe connection',
      'two-way mounting design',
      'Easy screen overview'
    ]
  },
  {
    id: 'c855a5791d28428fba9466aca6db6822',
    model: '116-5861-0.18.2801116-5861-0.18.2803',
    title: 'Autro Sense',
    link: 'http://product.autronicafire.com/products/fire-and-gas-detection-systems/detectors-for-special-requirements/aspirating-hssd/autrosense-series/autrosense-cascade/',
    roomRoute: 'electrical-switching-room',
    facilityRoute: 'data-center',
    pos: { top: 56, left: 15, unit: '%' },
    content: [
      'AutroSense Cascade is a scalable aspirating smoke detection solution that makes installation easier, maintenance quicker, and takes applications further than traditional air sampling detectors'
    ],
    productImage: 'autro-sense.png',
    featureList: [
      'Eight detector modules controlled via one display ',
      'Easy pipe connection',
      'two-way mounting design',
      'Easy screen overview'
    ]
  },
  {
    id: '449b01709bb84f5895f9be02fb864e22',
    model: '116-5861-0.18.2801116-5861-0.18.2803',
    title: 'Autro Sense',
    link: 'http://product.autronicafire.com/products/fire-and-gas-detection-systems/detectors-for-special-requirements/aspirating-hssd/autrosense-series/autrosense-cascade/',
    roomRoute: 'electrical-switching-room',
    facilityRoute: 'e-house',
    pos: { top: 55, left: 13, unit: '%' },
    content: [
      'AutroSense Cascade is a scalable aspirating smoke detection solution that makes installation easier, maintenance quicker, and takes applications further than traditional air sampling detectors'
    ],
    productImage: 'autro-sense.png',
    featureList: [
      'Eight detector modules controlled via one display ',
      'Easy pipe connection',
      'two-way mounting design',
      'Easy screen overview'
    ]
  },
  {
    id: '1cc9a1761c1741f1b038189bf7a5b76f',
    model: '116-5861-021.3000',
    title: 'FireRay 3000',
    link: 'http://product.autronicafire.com/products/fire-and-gas-detection-systems/detectors-for-special-requirements/beam/fireray/fireray-3000/',
    roomRoute: 'foyer',
    facilityRoute: 'hotel',
    pos: { top: 41, left: 10, unit: '%' },
    content: [
      'The Fireray® 3000 End to End infrared Optical Beam Smoke Detector has been designed using the latest optical technology, incorporating modern industrial, electronic, and software techniques. This detector offers cost effective protection of large, open areas with high ceilings.'
    ],
    productImage: 'fire-ray-3000.jpg',
    featureList: [
      'Allows for 2 Detectors per System Controller',
      'Range 5 to 120 meters, configurable per set of Detectors',
      'Integral Laser Alignment in Receiver',
      'Separate Fire and Fault Relays per Detector',
      'Programmable Sensitivity and Fire/Fault delay',
      'Automatic Gain Control (AGC) for drift compensation',
      'Transmitter can be powered from Controller'
    ]
  },
  {
    id: '8200317afdcb4436a7efb7b21e22909e',
    model: '116-5861-021.3000',
    title: 'FireRay 3000',
    link: 'http://product.autronicafire.com/products/fire-and-gas-detection-systems/detectors-for-special-requirements/beam/fireray/fireray-3000/',
    roomRoute: 'foyer',
    facilityRoute: 'hospital',
    pos: { top: 40, left: 13, unit: '%' },
    content: [
      'The Fireray® 3000 End to End infrared Optical Beam Smoke Detector has been designed using the latest optical technology, incorporating modern industrial, electronic, and software techniques. This detector offers cost effective protection of large, open areas with high ceilings.'
    ],
    productImage: 'fire-ray-3000.jpg',
    featureList: [
      'Allows for 2 Detectors per System Controller',
      'Range 5 to 120 meters, configurable per set of Detectors',
      'Integral Laser Alignment in Receiver',
      'Separate Fire and Fault Relays per Detector',
      'Programmable Sensitivity and Fire/Fault delay',
      'Automatic Gain Control (AGC) for drift compensation',
      'Transmitter can be powered from Controller'
    ]
  },
  {
    id: '4f9d958d575c4035bbdee2357402a95d',
    model: '116-014146-232',
    title: 'Autro Point Gas-detector',
    link: 'http://product.autronicafire.com/products/fire-and-gas-detection-systems/detectors-for-special-requirements/gas/infrared-hydrocarbon/point/hc200/',
    roomRoute: 'lab',
    facilityRoute: 'hospital',
    pos: { top: 29, left: 10, unit: '%' },
    content: [
      'The AutroPoint HC200 is an infrared combustible gas detector that provides continuous, fixed monitoring of flammable hydrocarbon gases from 0 % to 100 % Lower Explosive Limit. Standard device outputs include an electrically isolated 4-20 mA signal with HART communication protocol, and RS-485 serial communication. Ideally suited for protection of challenging on/offshore oil and gas facilities and other downstream hydrocarbon applications, the HC200 is globally certified for use in Class I, Divisions 1 and 2, and Zones 1 and 2 hazardous areas.'
    ],
    productImage: 'atro-point.jpg',
    featureList: [
      'Allows for 2 Detectors per System Controller',
      'Range 5 to 120 meters, configurable per set of Detectors',
      'Integral Laser Alignment in Receiver',
      'Separate Fire and Fault Relays per Detector',
      'Programmable Sensitivity and Fire/Fault delay',
      'Automatic Gain Control (AGC) for drift compensation',
      'Transmitter can be powered from Controller',
      'SIL 2 model certified to IEC 61508 by exida®',
      'Explosion-proof (Ex de protection available for maximum versatility) stainless steel housing with tethered weather protection baffle',
      'Built-in tri-color LED eliminates need for external display module',
      'Optional Universal Display for remote calibration',
      'Heated sapphire optics deliver long-lasting, high performance detection capability',
      'Immune to damage from exposure to constant background gases or to high gas concentrations',
      'Global approvals including FM, CSA, DNV/MED, ATEX and IECEx certifications',
      'Gas performance verification by FM/CSA/ DEMKO.',
      'Fast response output option available (T90<2s)'
    ]
  },
  {
    id: '0110c03ffe5f465596e8943439eb37a2',
    model: '116-Autromaster-PC-V',
    title: 'AutroMaster',
    link: 'http://product.autronicafire.com/products/presentation-systems/autromaster-v/',
    roomRoute: 'technical-control-room',
    facilityRoute: 'data-center',
    pos: { top: 58, left: 64, unit: '%' },
    content: [
      'AutroMaster V is a graphical presentation system that can be used together with Autronica’s interactive fire detection systems. The system can be connected to large numbers of fire alarm panels of different types.',
      'AutroMaster V uses color graphics for the display of system events, providing detailed information – so necessary actions can be taken.'
    ],
    productImage: 'autro-master.jpg',
    featureList: [
      'Easy-to-understand graphical presentation of alarmed areas and events that may occur',
      'Intuitive control and monitoring interface',
      'Powerful zoom functions to monitor all areas in detail',
      'Group management',
      'Report generator'
    ]
  },
  {
    id: '9511071fe8d2425fbdcdd1c7a4dc4c19',
    model: '116-Autromaster-PC-V',
    title: 'AutroMaster',
    link: 'http://product.autronicafire.com/products/presentation-systems/autromaster-v/',
    roomRoute: 'technical-control-room',
    facilityRoute: 'hotel',
    pos: { top: 58, left: 64, unit: '%' },
    content: [
      'AutroMaster V is a graphical presentation system that can be used together with Autronica’s interactive fire detection systems. The system can be connected to large numbers of fire alarm panels of different types.',
      'AutroMaster V uses color graphics for the display of system events, providing detailed information – so necessary actions can be taken.'
    ],
    productImage: 'autro-master.jpg',
    featureList: [
      'Easy-to-understand graphical presentation of alarmed areas and events that may occur',
      'Intuitive control and monitoring interface',
      'Powerful zoom functions to monitor all areas in detail',
      'Group management',
      'Report generator'
    ]
  },
  {
    id: 'ec8225e39eab4b42a717c7122492e4ec',
    model: '116-Autromaster-PC-V',
    title: 'AutroMaster',
    link: 'http://product.autronicafire.com/products/presentation-systems/autromaster-v/',
    roomRoute: 'technical-control-room',
    facilityRoute: 'hospital',
    pos: { top: 58, left: 64, unit: '%' },
    content: [
      'AutroMaster V is a graphical presentation system that can be used together with Autronica’s interactive fire detection systems. The system can be connected to large numbers of fire alarm panels of different types.',
      'AutroMaster V uses color graphics for the display of system events, providing detailed information – so necessary actions can be taken.'
    ],
    productImage: 'autro-master.jpg',
    featureList: [
      'Easy-to-understand graphical presentation of alarmed areas and events that may occur',
      'Intuitive control and monitoring interface',
      'Powerful zoom functions to monitor all areas in detail',
      'Group management',
      'Report generator'
    ]
  },
  {
    id: '9a76b66a788d4b2ca6abc6f3947de252',
    model: '116-Autromaster-PC-V',
    title: 'AutroMaster',
    link: 'http://product.autronicafire.com/products/presentation-systems/autromaster-v/',
    roomRoute: 'technical-control-room',
    facilityRoute: 'cruise',
    pos: { top: 51, left: 64, unit: '%' },
    content: [
      'AutroMaster V is a graphical presentation system that can be used together with Autronica’s interactive fire detection systems. The system can be connected to large numbers of fire alarm panels of different types.',
      'AutroMaster V uses color graphics for the display of system events, providing detailed information – so necessary actions can be taken.'
    ],
    productImage: 'autro-master.jpg',
    featureList: [
      'Easy-to-understand graphical presentation of alarmed areas and events that may occur',
      'Intuitive control and monitoring interface',
      'Powerful zoom functions to monitor all areas in detail',
      'Group management',
      'Report generator'
    ]
  },
  {
    id: 'ad646658c1304cacbae135fa7506794d',
    model: '116-BF-300V2',
    title: 'Manual call point',
    link: 'http://product.autronicafire.com/products/fire-and-gas-detection-systems/manual-call-points/300-series/bf-300v2/',
    roomRoute: 'data-hall',
    facilityRoute: 'data-center',
    pos: { top: 48, left: 14, unit: '%' },
    content: [
      'BF-300V2 is a manual call point to be used indoors. The call point is designed to be used with Autronica’s interactive fire detection systems and comprises the SelfVerify function. ',
      'This function ensures the highest grade of reliability and the lowest degree of manual testing, due to all units comprising this function are automatically self-tested once every 24-hours.'
    ],
    productImage: 'mcp.jpg',
    featureList: []
  },
  {
    id: '4e93bda378c04f499602c16afcbef4b2',
    model: '116-BF-300V2',
    title: 'Manual call point',
    link: 'http://product.autronicafire.com/products/fire-and-gas-detection-systems/manual-call-points/300-series/bf-300v2/',
    roomRoute: 'technical-control-room',
    facilityRoute: 'data-center',
    pos: { top: 55, left: 16, unit: '%' },
    content: [
      'BF-300V2 is a manual call point to be used indoors. The call point is designed to be used with Autronica’s interactive fire detection systems and comprises the SelfVerify function. ',
      'This function ensures the highest grade of reliability and the lowest degree of manual testing, due to all units comprising this function are automatically self-tested once every 24-hours.'
    ],
    productImage: 'mcp.jpg',
    featureList: []
  },
  {
    id: 'a0066305946a47cfa2b415cb7af93b75',
    model: '116-BF-300V2',
    title: 'Manual call point',
    link: 'http://product.autronicafire.com/products/fire-and-gas-detection-systems/manual-call-points/300-series/bf-300v2/',
    roomRoute: 'kitchen',
    facilityRoute: 'data-center',
    pos: { top: 55, left: 57, unit: '%' },
    content: [
      'BF-300V2 is a manual call point to be used indoors. The call point is designed to be used with Autronica’s interactive fire detection systems and comprises the SelfVerify function. ',
      'This function ensures the highest grade of reliability and the lowest degree of manual testing, due to all units comprising this function are automatically self-tested once every 24-hours.'
    ],
    productImage: 'mcp.jpg',
    featureList: []
  },
  {
    id: '52c2eeaced2b412eacd9faa03c3e243e',
    model: '116-BF-300V2',
    title: 'Manual call point',
    link: 'http://product.autronicafire.com/products/fire-and-gas-detection-systems/manual-call-points/300-series/bf-300v2/',
    roomRoute: 'foyer',
    facilityRoute: 'hotel',
    pos: { top: 78, left: 96, unit: '%' },
    content: [
      'BF-300V2 is a manual call point to be used indoors. The call point is designed to be used with Autronica’s interactive fire detection systems and comprises the SelfVerify function. ',
      'This function ensures the highest grade of reliability and the lowest degree of manual testing, due to all units comprising this function are automatically self-tested once every 24-hours.'
    ],
    productImage: 'mcp.jpg',
    featureList: []
  },
  {
    id: 'a30b4b1ad0c8401692b648cc535f0385',
    model: '116-BF-300V2',
    title: 'Manual call point',
    link: 'http://product.autronicafire.com/products/fire-and-gas-detection-systems/manual-call-points/300-series/bf-300v2/',
    roomRoute: 'kitchen',
    facilityRoute: 'hotel',
    pos: { top: 55, left: 57, unit: '%' },
    content: [
      'BF-300V2 is a manual call point to be used indoors. The call point is designed to be used with Autronica’s interactive fire detection systems and comprises the SelfVerify function. ',
      'This function ensures the highest grade of reliability and the lowest degree of manual testing, due to all units comprising this function are automatically self-tested once every 24-hours.'
    ],
    productImage: 'mcp.jpg',
    featureList: []
  },
  {
    id: '1d1df7dd66c84cc7a66907a3443fc901',
    model: '116-BF-300V2',
    title: 'Manual call point',
    link: 'http://product.autronicafire.com/products/fire-and-gas-detection-systems/manual-call-points/300-series/bf-300v2/',
    roomRoute: 'technical-control-room',
    facilityRoute: 'hotel',
    pos: { top: 55, left: 16, unit: '%' },
    content: [
      'BF-300V2 is a manual call point to be used indoors. The call point is designed to be used with Autronica’s interactive fire detection systems and comprises the SelfVerify function. ',
      'This function ensures the highest grade of reliability and the lowest degree of manual testing, due to all units comprising this function are automatically self-tested once every 24-hours.'
    ],
    productImage: 'mcp.jpg',
    featureList: []
  },
  {
    id: '9c303f254d4f40b39513e09d191e6210',
    model: '116-BF-300V2',
    title: 'Manual call point',
    link: 'http://product.autronicafire.com/products/fire-and-gas-detection-systems/manual-call-points/300-series/bf-300v2/',
    roomRoute: 'nurses-station',
    facilityRoute: 'hospital',
    pos: { top: 50, left: 12, unit: '%' },
    content: [
      'BF-300V2 is a manual call point to be used indoors. The call point is designed to be used with Autronica’s interactive fire detection systems and comprises the SelfVerify function. ',
      'This function ensures the highest grade of reliability and the lowest degree of manual testing, due to all units comprising this function are automatically self-tested once every 24-hours.'
    ],
    productImage: 'mcp.jpg',
    featureList: []
  },
  {
    id: '754b670effe340e5adf4af80a9f66ccc',
    model: '116-BF-300V2',
    title: 'Manual call point',
    link: 'http://product.autronicafire.com/products/fire-and-gas-detection-systems/manual-call-points/300-series/bf-300v2/',
    roomRoute: 'technical-control-room',
    facilityRoute: 'hospital',
    pos: { top: 55, left: 16, unit: '%' },
    content: [
      'BF-300V2 is a manual call point to be used indoors. The call point is designed to be used with Autronica’s interactive fire detection systems and comprises the SelfVerify function. ',
      'This function ensures the highest grade of reliability and the lowest degree of manual testing, due to all units comprising this function are automatically self-tested once every 24-hours.'
    ],
    productImage: 'mcp.jpg',
    featureList: []
  },
  {
    id: 'ec9a7d9ab2b943b59101fa286a828d7b',
    model: '116-BF-300V2',
    title: 'Manual call point',
    link: 'http://product.autronicafire.com/products/fire-and-gas-detection-systems/manual-call-points/300-series/bf-300v2/',
    roomRoute: 'foyer',
    facilityRoute: 'hospital',
    pos: { top: 80, left: 90, unit: '%' },
    content: [
      'BF-300V2 is a manual call point to be used indoors. The call point is designed to be used with Autronica’s interactive fire detection systems and comprises the SelfVerify function. ',
      'This function ensures the highest grade of reliability and the lowest degree of manual testing, due to all units comprising this function are automatically self-tested once every 24-hours.'
    ],
    productImage: 'mcp.jpg',
    featureList: []
  },
  {
    id: '24b3a1490b2f4897b884207cb927acb5',
    model: '116-BF-300V2',
    title: 'Manual call point',
    link: 'http://product.autronicafire.com/products/fire-and-gas-detection-systems/manual-call-points/300-series/bf-300v2/',
    roomRoute: 'technical-control-room',
    facilityRoute: 'cruise',
    pos: { top: 52, left: 15, unit: '%' },
    content: [
      'BF-300V2 is a manual call point to be used indoors. The call point is designed to be used with Autronica’s interactive fire detection systems and comprises the SelfVerify function. ',
      'This function ensures the highest grade of reliability and the lowest degree of manual testing, due to all units comprising this function are automatically self-tested once every 24-hours.'
    ],
    productImage: 'mcp.jpg',
    featureList: []
  },
  {
    id: '23e03b7da62e4c0bb5ce6945fd671355',
    model: '116-BF-300V2',
    title: 'Manual call point',
    link: 'http://product.autronicafire.com/products/fire-and-gas-detection-systems/manual-call-points/300-series/bf-300v2/',
    roomRoute: 'data-hall',
    facilityRoute: 'e-house',
    pos: { top: 58, left: 11, unit: '%' },
    content: [
      'BF-300V2 is a manual call point to be used indoors. The call point is designed to be used with Autronica’s interactive fire detection systems and comprises the SelfVerify function. ',
      'This function ensures the highest grade of reliability and the lowest degree of manual testing, due to all units comprising this function are automatically self-tested once every 24-hours.'
    ],
    productImage: 'mcp.jpg',
    featureList: []
  },
  {
    id: 'c938f6444db4434787b93d0ee121fa63',
    model: '116-BF-502',
    title: 'Manual call point',
    link: 'http://product.autronicafire.com/products/fire-and-gas-detection-systems/manual-call-points/300-series/bf-300v2/',
    roomRoute: 'reliquefication-plant',
    facilityRoute: 'lng',
    pos: { top: 67, left: 2, unit: '%' },
    content: [
      'BF-502 is a manual call point to be used in harsh environmental conditions. The call point is designed to be used with Autronica’s interactive fire detection system and comprises the SelfVerify function. ',
      'This function ensures the highest grade of reliability and the lowest degree of manual testing, due to all units comprising this function are automatically self-tested once every 24 hours'
    ],
    productImage: 'mcp.jpg',
    featureList: []
  },
  {
    id: '8cf89d59cdab44fd94204d0aa4e9c396',
    model: '116-BF-502',
    title: 'Manual call point',
    link: 'http://product.autronicafire.com/products/fire-and-gas-detection-systems/manual-call-points/500-series/bf-500v2-ex/',
    roomRoute: 'nacelle',
    facilityRoute: 'wind-farm',
    pos: { top: 36, left: 47, unit: '%' },
    content: [
      'BF-502 is a manual call point to be used in harsh environmental conditions. The call point is designed to be used with Autronica’s interactive fire detection system and comprises the SelfVerify function. ',
      'This function ensures the highest grade of reliability and the lowest degree of manual testing, due to all units comprising this function are automatically self-tested once every 24 hours'
    ],
    productImage: 'mcp.jpg',
    featureList: []
  },
  {
    id: 'c9fcc3eae12c45559f00c5079e9026b7',
    model: '116-BF-502',
    title: 'Manual call point',
    link: 'http://product.autronicafire.com/products/fire-and-gas-detection-systems/manual-call-points/500-series/bf-500v2-ex/',
    roomRoute: 'tower',
    facilityRoute: 'wind-farm',
    pos: { top: 47, left: 46, unit: '%' },
    content: [
      'BF-502 is a manual call point to be used in harsh environmental conditions. The call point is designed to be used with Autronica’s interactive fire detection system and comprises the SelfVerify function. ',
      'This function ensures the highest grade of reliability and the lowest degree of manual testing, due to all units comprising this function are automatically self-tested once every 24 hours'
    ],
    productImage: 'mcp.jpg',
    featureList: []
  },
  {
    id: 'd6151302f51b4fc8973f8a987b6c179d',
    model: '116-BG-201',
    title: 'Autro Flame',
    link: 'http://product.autronicafire.com/products/fire-and-gas-detection-systems/detectors-for-special-requirements/flame/dual-ir/bg-201/',
    roomRoute: 'transformer-chiller-generator',
    facilityRoute: 'data-center',
    pos: { top: 61, left: 4, unit: '%' },
    content: [
      'BG‐201 is a point flame detector for detection of fires involving combustion of carbonaceous materials. The detector has a high IP rating making it suitable for the harshest environments. The advanced signal processing and DYFI+ intelligence ensures that the detector has a high immunity to any nuisance alarm source, combined with fast detection of real fires. '
    ],
    productImage: '116-bg201.png',
    featureList: [
      '3 Different sensitivity settings ',
      'Short circuit isolator in each detector',
      'Solar resistant',
      'Very fast fire detection',
      'Not blinded by oil film on window',
      'High degree of immunity to false alarm sources',
      'EN54‐10, EN54‐17 approved',
      'Designed to meet the requirement of the major marine classification societies'
    ]
  },
  {
    id: '3a0a807fb155476f9f99516c73846d21',
    model: '116-BG-201',
    title: 'Autro Flame',
    link: 'http://product.autronicafire.com/products/fire-and-gas-detection-systems/detectors-for-special-requirements/flame/dual-ir/bg-201/',
    roomRoute: 'engine-room',
    facilityRoute: 'cruise',
    pos: { top: 24, left: 41, unit: '%' },
    content: [
      'BG‐201 is a point flame detector for detection of fires involving combustion of carbonaceous materials. The detector has a high IP rating making it suitable for the harshest environments. The advanced signal processing and DYFI+ intelligence ensures that the detector has a high immunity to any nuisance alarm source, combined with fast detection of real fires. '
    ],
    productImage: '116-bg201.png',
    featureList: [
      '3 Different sensitivity settings ',
      'Short circuit isolator in each detector',
      'Solar resistant',
      'Very fast fire detection',
      'Not blinded by oil film on window',
      'High degree of immunity to false alarm sources',
      'EN54‐10, EN54‐17 approved',
      'Designed to meet the requirement of the major marine classification societies'
    ]
  },
  {
    id: 'bc09706a64964c968191733597f54783',
    model: '116-BG-201',
    title: 'Autro Flame',
    link: 'http://product.autronicafire.com/products/fire-and-gas-detection-systems/detectors-for-special-requirements/flame/dual-ir/bg-201/',
    roomRoute: 'engine-room',
    facilityRoute: 'lng',
    pos: { top: 22, left: 41, unit: '%' },
    content: [
      'BG‐201 is a point flame detector for detection of fires involving combustion of carbonaceous materials. The detector has a high IP rating making it suitable for the harshest environments. The advanced signal processing and DYFI+ intelligence ensures that the detector has a high immunity to any nuisance alarm source, combined with fast detection of real fires. '
    ],
    productImage: '116-bg201.png',
    featureList: [
      '3 Different sensitivity settings ',
      'Short circuit isolator in each detector',
      'Solar resistant',
      'Very fast fire detection',
      'Not blinded by oil film on window',
      'High degree of immunity to false alarm sources',
      'EN54‐10, EN54‐17 approved',
      'Designed to meet the requirement of the major marine classification societies'
    ]
  },
  {
    id: '8aad069272744769a392d9f5d1ea4571',
    model: '116-BG-201',
    title: 'Autro Flame',
    link: 'http://product.autronicafire.com/products/fire-and-gas-detection-systems/detectors-for-special-requirements/flame/dual-ir/bg-201/',
    roomRoute: 'nacelle',
    facilityRoute: 'wind-farm',
    pos: { top: 25, left: 50, unit: '%' },
    content: [
      'BG‐201 is a point flame detector for detection of fires involving combustion of carbonaceous materials. The detector has a high IP rating making it suitable for the harshest environments. The advanced signal processing and DYFI+ intelligence ensures that the detector has a high immunity to any nuisance alarm source, combined with fast detection of real fires. '
    ],
    productImage: '116-bg201.png',
    featureList: [
      '3 Different sensitivity settings ',
      'Short circuit isolator in each detector',
      'Solar resistant',
      'Very fast fire detection',
      'Not blinded by oil film on window',
      'High degree of immunity to false alarm sources',
      'EN54‐10, EN54‐17 approved',
      'Designed to meet the requirement of the major marine classification societies'
    ]
  },
  {
    id: '7d06db3a927f421da4b98ed4bd1f76af',
    model: '116-BG-201',
    title: 'Autro Flame',
    link: 'http://product.autronicafire.com/products/fire-and-gas-detection-systems/detectors-for-special-requirements/flame/dual-ir/bg-201/',
    roomRoute: 'transformer-chiller-generator',
    facilityRoute: 'e-house',
    pos: { top: 20, left: 18, unit: '%' },
    content: [
      'BG‐201 is a point flame detector for detection of fires involving combustion of carbonaceous materials. The detector has a high IP rating making it suitable for the harshest environments. The advanced signal processing and DYFI+ intelligence ensures that the detector has a high immunity to any nuisance alarm source, combined with fast detection of real fires. '
    ],
    productImage: '116-bg201.png',
    featureList: [
      '3 Different sensitivity settings ',
      'Short circuit isolator in each detector',
      'Solar resistant',
      'Very fast fire detection',
      'Not blinded by oil film on window',
      'High degree of immunity to false alarm sources',
      'EN54‐10, EN54‐17 approved',
      'Designed to meet the requirement of the major marine classification societies'
    ]
  },
  {
    id: '1072da5a5e42405595d4aa7e4260bcc9',
    model: '116-BG-201F',
    title: 'Autro Flame',
    link: 'http://product.autronicafire.com/products/fire-and-gas-detection-systems/detectors-for-special-requirements/flame/dual-ir/facade-protection/',
    roomRoute: 'façade',
    facilityRoute: 'data-center',
    pos: { top: 22, left: 18, unit: '%' },
    content: [
      'AutroFlame BG-201F is a robust solution for protecting building Façades. An increasing trend of arsen makes this solution ideal for very early detection of fires from outside the buildings.',
      'The solution consists of BG-201 Flame detector, mounting arm, weather protection & FOV limiter.',
      'The solution is designed to isolate the detection of the Façade, avoiding interference from areas around the building.'
    ],
    productImage: '116-bg201.png',
    featureList: []
  },
  {
    id: '266d49f06b164e4b92c5d8b791d71ed2',
    model: '116-BG-201F',
    title: 'Autro Flame',
    link: 'http://product.autronicafire.com/products/fire-and-gas-detection-systems/detectors-for-special-requirements/flame/dual-ir/facade-protection/',
    roomRoute: 'façade',
    facilityRoute: 'hotel',
    pos: { top: 22, left: 18, unit: '%' },
    content: [
      'AutroFlame BG-201F is a robust solution for protecting building Façades. An increasing trend of arsen makes this solution ideal for very early detection of fires from outside the buildings.',
      'The solution consists of BG-201 Flame detector, mounting arm, weather protection & FOV limiter.',
      'The solution is designed to isolate the detection of the Façade, avoiding interference from areas around the building.'
    ],
    productImage: '116-bg201.png',
    featureList: []
  },
  {
    id: '10888b48367640f486d3c0f4bb61d9f4',
    model: '116-BG-201F',
    title: 'Autro Flame',
    link: 'http://product.autronicafire.com/products/fire-and-gas-detection-systems/detectors-for-special-requirements/flame/dual-ir/facade-protection/',
    roomRoute: 'façade',
    facilityRoute: 'hospital',
    pos: { top: 22, left: 18, unit: '%' },
    content: [
      'AutroFlame BG-201F is a robust solution for protecting building Façades. An increasing trend of arsen makes this solution ideal for very early detection of fires from outside the buildings.',
      'The solution consists of BG-201 Flame detector, mounting arm, weather protection & FOV limiter.',
      'The solution is designed to isolate the detection of the Façade, avoiding interference from areas around the building.'
    ],
    productImage: '116-bg201.png',
    featureList: []
  },
  {
    id: 'b527058239534ac8b95f868c81a37b88',
    model: '116-BG-201F',
    title: 'Autro Flame',
    link: 'http://product.autronicafire.com/products/fire-and-gas-detection-systems/detectors-for-special-requirements/flame/dual-ir/facade-protection/',
    roomRoute: 'façade',
    facilityRoute: 'e-house',
    pos: { top: 22, left: 18, unit: '%' },
    content: [
      'AutroFlame BG-201F is a robust solution for protecting building Façades. An increasing trend of arsen makes this solution ideal for very early detection of fires from outside the buildings.',
      'The solution consists of BG-201 Flame detector, mounting arm, weather protection & FOV limiter.',
      'The solution is designed to isolate the detection of the Façade, avoiding interference from areas around the building.'
    ],
    productImage: '116-bg201.png',
    featureList: []
  },
  {
    id: 'd1bf85cb8423453bb43702d33afcd47b',
    model: '116-BS-420',
    title: 'Autro Safe',
    link: 'http://product.autronicafire.com/products/fire-and-gas-detection-systems/autrosafe-4/bs-420/',
    roomRoute: 'data-hall',
    facilityRoute: 'data-center',
    pos: { top: 56, left: 64, unit: '%' },
    content: [
      'BS-420 is a complete fire alarm control panel with full operation capabilities. The panel serves as an operating panel for one or several defined operation zones. All alarm handling and system features can be controlled and monitored from the panel.'
    ],
    productImage: '116-BS-420.png',
    featureList: [
      'SelfVerify function for automatic testing of detectors',
      'Automatic addressing of detectors',
      'Supports 64 panels in a network system ',
      'Integrated fire and gas detection',
      'SIL2 approved'
    ]
  },
  {
    id: '6f4d9eb3583a4cb18133b13e001b565f',
    model: '116-BS-420',
    title: 'Autro Safe',
    link: 'http://product.autronicafire.com/products/fire-and-gas-detection-systems/autrosafe-4/bs-420/',
    roomRoute: 'technical-control-room',
    facilityRoute: 'data-center',
    pos: { top: 40, left: 22, unit: '%' },
    content: [
      'BS-420 is a complete fire alarm control panel with full operation capabilities. The panel serves as an operating panel for one or several defined operation zones. All alarm handling and system features can be controlled and monitored from the panel.'
    ],
    productImage: '116-BS-420.png',
    featureList: [
      'SelfVerify function for automatic testing of detectors',
      'Automatic addressing of detectors',
      'Supports 64 panels in a network system ',
      'Integrated fire and gas detection',
      'SIL2 approved'
    ]
  },
  {
    id: 'fa5af860482b4b4a8beb0a576f4ef135',
    model: '116-BS-420',
    title: 'Autro Safe',
    link: 'http://product.autronicafire.com/products/fire-and-gas-detection-systems/autrosafe-4/bs-420/',
    roomRoute: 'foyer',
    facilityRoute: 'hotel',
    pos: { top: 80, left: 90, unit: '%' },
    content: [
      'BS-420 is a complete fire alarm control panel with full operation capabilities. The panel serves as an operating panel for one or several defined operation zones. All alarm handling and system features can be controlled and monitored from the panel.'
    ],
    productImage: '116-BS-420.png',
    featureList: [
      'SelfVerify function for automatic testing of detectors',
      'Automatic addressing of detectors',
      'Supports 64 panels in a network system ',
      'Integrated fire and gas detection',
      'SIL2 approved'
    ]
  },
  {
    id: '9df9d06a264d4c10b90d77eb50ae8dd9',
    model: '116-BS-420',
    title: 'Autro Safe',
    link: 'http://product.autronicafire.com/products/fire-and-gas-detection-systems/autrosafe-4/bs-420/',
    roomRoute: 'technical-control-room',
    facilityRoute: 'hotel',
    pos: { top: 40, left: 22, unit: '%' },
    content: [
      'BS-420 is a complete fire alarm control panel with full operation capabilities. The panel serves as an operating panel for one or several defined operation zones. All alarm handling and system features can be controlled and monitored from the panel.'
    ],
    productImage: '116-BS-420.png',
    featureList: [
      'SelfVerify function for automatic testing of detectors',
      'Automatic addressing of detectors',
      'Supports 64 panels in a network system ',
      'Integrated fire and gas detection',
      'SIL2 approved'
    ]
  },
  {
    id: '0a7fcd63b9bb4a879c225480e771e160',
    model: '116-BS-420',
    title: 'Autro Safe',
    link: 'http://product.autronicafire.com/products/fire-and-gas-detection-systems/autrosafe-4/bs-420/',
    roomRoute: 'technical-control-room',
    facilityRoute: 'hospital',
    pos: { top: 40, left: 22, unit: '%' },
    content: [
      'BS-420 is a complete fire alarm control panel with full operation capabilities. The panel serves as an operating panel for one or several defined operation zones. All alarm handling and system features can be controlled and monitored from the panel.'
    ],
    productImage: '116-BS-420.png',
    featureList: [
      'SelfVerify function for automatic testing of detectors',
      'Automatic addressing of detectors',
      'Supports 64 panels in a network system ',
      'Integrated fire and gas detection',
      'SIL2 approved'
    ]
  },
  {
    id: 'c4e954a924454b79810f3129d9e496a0',
    model: '116-BS-420',
    title: 'Autro Safe',
    link: 'http://product.autronicafire.com/products/fire-and-gas-detection-systems/autrosafe-4/bs-420/',
    roomRoute: 'foyer',
    facilityRoute: 'hospital',
    pos: { top: 78, left: 97, unit: '%' },
    content: [
      'BS-420 is a complete fire alarm control panel with full operation capabilities. The panel serves as an operating panel for one or several defined operation zones. All alarm handling and system features can be controlled and monitored from the panel.'
    ],
    productImage: '116-BS-420.png',
    featureList: [
      'SelfVerify function for automatic testing of detectors',
      'Automatic addressing of detectors',
      'Supports 64 panels in a network system ',
      'Integrated fire and gas detection',
      'SIL2 approved'
    ]
  },
  {
    id: 'ac86a39563f54bebaa86a3c42417fcda',
    model: '116-BS-420',
    title: 'Autro Safe',
    link: 'http://product.autronicafire.com/products/fire-and-gas-detection-systems/autrosafe-4/bs-420/',
    roomRoute: 'technical-control-room',
    facilityRoute: 'cruise',
    pos: { top: 39, left: 18, unit: '%' },
    content: [
      'BS-420 is a complete fire alarm control panel with full operation capabilities. The panel serves as an operating panel for one or several defined operation zones. All alarm handling and system features can be controlled and monitored from the panel.'
    ],
    productImage: '116-BS-420.png',
    featureList: [
      'SelfVerify function for automatic testing of detectors',
      'Automatic addressing of detectors',
      'Supports 64 panels in a network system ',
      'Integrated fire and gas detection',
      'SIL2 approved'
    ]
  },
  {
    id: '583d212aa6a94ca990cb06acff1840e3',
    model: '116-BS-420',
    title: 'Autro Safe',
    link: 'http://product.autronicafire.com/products/fire-and-gas-detection-systems/autrosafe-4/bs-420/',
    roomRoute: 'nacelle',
    facilityRoute: 'wind-farm',
    pos: { top: 31, left: 54, unit: '%' },
    content: [
      'BS-420 is a complete fire alarm control panel with full operation capabilities. The panel serves as an operating panel for one or several defined operation zones. All alarm handling and system features can be controlled and monitored from the panel.'
    ],
    productImage: '116-BS-420.png',
    featureList: [
      'SelfVerify function for automatic testing of detectors',
      'Automatic addressing of detectors',
      'Supports 64 panels in a network system ',
      'Integrated fire and gas detection',
      'SIL2 approved'
    ]
  },
  {
    id: 'e174de79ffa84d5fadd8f097c4566725',
    model: '116-BS-420',
    title: 'Autro Safe',
    link: 'http://product.autronicafire.com/products/fire-and-gas-detection-systems/autrosafe-4/bs-420/',
    roomRoute: 'tower',
    facilityRoute: 'wind-farm',
    pos: { top: 49, left: 54, unit: '%' },
    content: [
      'BS-420 is a complete fire alarm control panel with full operation capabilities. The panel serves as an operating panel for one or several defined operation zones. All alarm handling and system features can be controlled and monitored from the panel.'
    ],
    productImage: '116-BS-420.png',
    featureList: [
      'SelfVerify function for automatic testing of detectors',
      'Automatic addressing of detectors',
      'Supports 64 panels in a network system ',
      'Integrated fire and gas detection',
      'SIL2 approved'
    ]
  },
  {
    id: 'aff0dd9244804872b58ada17199c86a4',
    model: '116-BS-420',
    title: 'Autro Safe',
    link: 'http://product.autronicafire.com/products/fire-and-gas-detection-systems/autrosafe-4/bs-420/',
    roomRoute: 'data-hall',
    facilityRoute: 'e-house',
    pos: { top: 64, left: 66, unit: '%' },
    content: [
      'BS-420 is a complete fire alarm control panel with full operation capabilities. The panel serves as an operating panel for one or several defined operation zones. All alarm handling and system features can be controlled and monitored from the panel.'
    ],
    productImage: '116-BS-420.png',
    featureList: [
      'SelfVerify function for automatic testing of detectors',
      'Automatic addressing of detectors',
      'Supports 64 panels in a network system ',
      'Integrated fire and gas detection',
      'SIL2 approved'
    ]
  },
  {
    id: 'f3d897428f4544918327925df58af08b',
    model: '116-M6040',
    title: 'Sounder and beacon',
    link: 'http://product.autronicafire.com/products/omicron-special-detection/standard-accessories/alarm-lights-and-horns/ex-combination-alarm-bexcs110/',
    roomRoute: 'nacelle',
    facilityRoute: 'wind-farm',
    pos: { top: 17, left: 84, unit: '%' },
    content: [
      'The flameproof BExCS110-05 combination alarm sounders and Xenon beacons are suitable for Zone 1 & Zone 2 applications.'
    ],
    productImage: '116-M6040.png',
    featureList: [
      'Automatic synchronization on multi-beacon & sounder systems',
      'Xenon tubes mechanically secured against shock & vibration'
    ]
  },
  {
    id: '4d32592083e5489091f4cfd5fecf3002',
    model: '116-M6040',
    title: 'Sounder and beacon',
    link: 'http://product.autronicafire.com/products/omicron-special-detection/standard-accessories/alarm-lights-and-horns/ex-combination-alarm-bexcs110/',
    roomRoute: 'tower',
    facilityRoute: 'wind-farm',
    pos: { top: 42, left: 43, unit: '%' },
    content: [
      'The flameproof BExCS110-05 combination alarm sounders and Xenon beacons are suitable for Zone 1 & Zone 2 applications.'
    ],
    productImage: '116-M6040.png',
    featureList: [
      'Automatic synchronization on multi-beacon & sounder systems',
      'Xenon tubes mechanically secured against shock & vibration'
    ]
  },
  {
    id: '70f53b8d1bd04aa1962f0fa4b03acf01',
    model: '116-V-430-S-VADR',
    title: 'AutroGuard',
    link: 'http://product.autronicafire.com/products/fire-and-gas-detection-systems/detectors/multicriteria-protectors/v-430-series/',
    roomRoute: 'emergency-power-supply-room',
    facilityRoute: 'data-center',
    pos: { top: 15, left: 54, unit: '%' },
    content: [
      'AutroGuard® V-430 multicriteria protector provides a new generation technology, eliminating false alarms. Smart solutions simplify installation and commissioning while increasing fire safety. ',
      'Extreme sensor dynamics provide fast and reliable smoke detection and removes nuisance alarms. With AutroGuard it is possible to cover even more application areas. This type of operation is configurable to Heat, Optical or Multisensor. ',
      'The pending patent SelfVerify 2.0 technology ensures that the protector is as reliable for its entire lifetime, as when it left the factory – reducing life cycle cost and giving a safer system.'
    ],
    productImage: 'autro-guard.jpg',
    featureList: [
      'Multi Angle / Multi Wavelength',
      'DYFI3D',
      'SelfVerify 2.0 (optional)',
      'Cover Detection (optional)',
      'False alarm immunity',
      'Dual Heat sensing technology',
      'Integrated sounder (optional)',
      'Integrated visual alarm device (VAD) (optional)',
      'Automatic addressing in the base',
      'Integrated short circuit isolator in the base'
    ]
  },
  {
    id: '4161ff656eeb4b09b51299e49c92c51e',
    model: '116-V-430-S-VADR',
    title: 'AutroGuard',
    link: 'http://product.autronicafire.com/products/fire-and-gas-detection-systems/detectors/multicriteria-protectors/v-430-series/',
    roomRoute: 'transformer-chiller-generator',
    facilityRoute: 'data-center',
    pos: { top: 15, left: 45, unit: '%' },
    content: [
      'AutroGuard® V-430 multicriteria protector provides a new generation technology, eliminating false alarms. Smart solutions simplify installation and commissioning while increasing fire safety. ',
      'Extreme sensor dynamics provide fast and reliable smoke detection and removes nuisance alarms. With AutroGuard it is possible to cover even more application areas. This type of operation is configurable to Heat, Optical or Multisensor. ',
      'The pending patent SelfVerify 2.0 technology ensures that the protector is as reliable for its entire lifetime, as when it left the factory – reducing life cycle cost and giving a safer system.'
    ],
    productImage: 'autro-guard.jpg',
    featureList: [
      'Multi Angle / Multi Wavelength',
      'DYFI3D',
      'SelfVerify 2.0 (optional)',
      'Cover Detection (optional)',
      'False alarm immunity',
      'Dual Heat sensing technology',
      'Integrated sounder (optional)',
      'Integrated visual alarm device (VAD) (optional)',
      'Automatic addressing in the base',
      'Integrated short circuit isolator in the base'
    ]
  },
  {
    id: '774b460ba7a94a888679fab309822d2e',
    model: '116-V-430-S-VADR',
    title: 'AutroGuard',
    link: 'http://product.autronicafire.com/products/fire-and-gas-detection-systems/detectors/multicriteria-protectors/v-430-series/',
    roomRoute: 'technical-control-room',
    facilityRoute: 'data-center',
    pos: { top: 10, left: 50, unit: '%' },
    content: [
      'AutroGuard® V-430 multicriteria protector provides a new generation technology, eliminating false alarms. Smart solutions simplify installation and commissioning while increasing fire safety. ',
      'Extreme sensor dynamics provide fast and reliable smoke detection and removes nuisance alarms. With AutroGuard it is possible to cover even more application areas. This type of operation is configurable to Heat, Optical or Multisensor. ',
      'The pending patent SelfVerify 2.0 technology ensures that the protector is as reliable for its entire lifetime, as when it left the factory – reducing life cycle cost and giving a safer system.'
    ],
    productImage: 'autro-guard.jpg',
    featureList: [
      'Multi Angle / Multi Wavelength',
      'DYFI3D',
      'SelfVerify 2.0 (optional)',
      'Cover Detection (optional)',
      'False alarm immunity',
      'Dual Heat sensing technology',
      'Integrated sounder (optional)',
      'Integrated visual alarm device (VAD) (optional)',
      'Automatic addressing in the base',
      'Integrated short circuit isolator in the base'
    ]
  },
  {
    id: '6da0f5740823406597a7ce00a7d09047',
    model: '116-V-430-S-VADR',
    title: 'AutroGuard',
    link: 'http://product.autronicafire.com/products/fire-and-gas-detection-systems/detectors/multicriteria-protectors/v-430-series/',
    roomRoute: 'office',
    facilityRoute: 'data-center',
    pos: { top: 10, left: 86, unit: '%' },
    content: [
      'AutroGuard® V-430 multicriteria protector provides a new generation technology, eliminating false alarms. Smart solutions simplify installation and commissioning while increasing fire safety. ',
      'Extreme sensor dynamics provide fast and reliable smoke detection and removes nuisance alarms. With AutroGuard it is possible to cover even more application areas. This type of operation is configurable to Heat, Optical or Multisensor. ',
      'The pending patent SelfVerify 2.0 technology ensures that the protector is as reliable for its entire lifetime, as when it left the factory – reducing life cycle cost and giving a safer system.'
    ],
    productImage: 'autro-guard.jpg',
    featureList: [
      'Multi Angle / Multi Wavelength',
      'DYFI3D',
      'SelfVerify 2.0 (optional)',
      'Cover Detection (optional)',
      'False alarm immunity',
      'Dual Heat sensing technology',
      'Integrated sounder (optional)',
      'Integrated visual alarm device (VAD) (optional)',
      'Automatic addressing in the base',
      'Integrated short circuit isolator in the base'
    ]
  },
  {
    id: 'f6b1ec46e72c4af0aec1bf3af9fb49bd',
    model: '116-V-430-S-VADR',
    title: 'AutroGuard',
    link: 'http://product.autronicafire.com/products/fire-and-gas-detection-systems/detectors/multicriteria-protectors/v-430-series/',
    roomRoute: 'kitchen',
    facilityRoute: 'data-center',
    pos: { top: 22, left: 34, unit: '%' },
    content: [
      'AutroGuard® V-430 multicriteria protector provides a new generation technology, eliminating false alarms. Smart solutions simplify installation and commissioning while increasing fire safety. ',
      'Extreme sensor dynamics provide fast and reliable smoke detection and removes nuisance alarms. With AutroGuard it is possible to cover even more application areas. This type of operation is configurable to Heat, Optical or Multisensor. ',
      'The pending patent SelfVerify 2.0 technology ensures that the protector is as reliable for its entire lifetime, as when it left the factory – reducing life cycle cost and giving a safer system.'
    ],
    productImage: 'autro-guard.jpg',
    featureList: [
      'Multi Angle / Multi Wavelength',
      'DYFI3D',
      'SelfVerify 2.0 (optional)',
      'Cover Detection (optional)',
      'False alarm immunity',
      'Dual Heat sensing technology',
      'Integrated sounder (optional)',
      'Integrated visual alarm device (VAD) (optional)',
      'Automatic addressing in the base',
      'Integrated short circuit isolator in the base'
    ]
  },
  {
    id: 'a2e29ce7c60843368f4518cfad13828e',
    model: '116-V-430-S-VADR',
    title: 'AutroGuard',
    link: 'http://product.autronicafire.com/products/fire-and-gas-detection-systems/detectors/multicriteria-protectors/v-430-series/',
    roomRoute: 'kitchen',
    facilityRoute: 'hotel',
    pos: { top: 22, left: 34, unit: '%' },
    content: [
      'AutroGuard® V-430 multicriteria protector provides a new generation technology, eliminating false alarms. Smart solutions simplify installation and commissioning while increasing fire safety. ',
      'Extreme sensor dynamics provide fast and reliable smoke detection and removes nuisance alarms. With AutroGuard it is possible to cover even more application areas. This type of operation is configurable to Heat, Optical or Multisensor. ',
      'The pending patent SelfVerify 2.0 technology ensures that the protector is as reliable for its entire lifetime, as when it left the factory – reducing life cycle cost and giving a safer system.'
    ],
    productImage: 'autro-guard.jpg',
    featureList: [
      'Multi Angle / Multi Wavelength',
      'DYFI3D',
      'SelfVerify 2.0 (optional)',
      'Cover Detection (optional)',
      'False alarm immunity',
      'Dual Heat sensing technology',
      'Integrated sounder (optional)',
      'Integrated visual alarm device (VAD) (optional)',
      'Automatic addressing in the base',
      'Integrated short circuit isolator in the base'
    ]
  },
  {
    id: '09b440b42a1745a6b7cbd5740d1be7f7',
    model: '116-V-430-S-VADR',
    title: 'AutroGuard',
    link: 'http://product.autronicafire.com/products/fire-and-gas-detection-systems/detectors/multicriteria-protectors/v-430-series/',
    roomRoute: 'conference-hall',
    facilityRoute: 'hotel',
    pos: { top: 15, left: 52, unit: '%' },
    content: [
      'AutroGuard® V-430 multicriteria protector provides a new generation technology, eliminating false alarms. Smart solutions simplify installation and commissioning while increasing fire safety. ',
      'Extreme sensor dynamics provide fast and reliable smoke detection and removes nuisance alarms. With AutroGuard it is possible to cover even more application areas. This type of operation is configurable to Heat, Optical or Multisensor. ',
      'The pending patent SelfVerify 2.0 technology ensures that the protector is as reliable for its entire lifetime, as when it left the factory – reducing life cycle cost and giving a safer system.'
    ],
    productImage: 'autro-guard.jpg',
    featureList: [
      'Multi Angle / Multi Wavelength',
      'DYFI3D',
      'SelfVerify 2.0 (optional)',
      'Cover Detection (optional)',
      'False alarm immunity',
      'Dual Heat sensing technology',
      'Integrated sounder (optional)',
      'Integrated visual alarm device (VAD) (optional)',
      'Automatic addressing in the base',
      'Integrated short circuit isolator in the base'
    ]
  },
  {
    id: 'e5695b4f96a74fc1886d489c449d0fc4',
    model: '116-V-430-S-VADR',
    title: 'AutroGuard',
    link: 'http://product.autronicafire.com/products/fire-and-gas-detection-systems/detectors/multicriteria-protectors/v-430-series/',
    roomRoute: 'technical-control-room',
    facilityRoute: 'hotel',
    pos: { top: 10, left: 50, unit: '%' },
    content: [
      'AutroGuard® V-430 multicriteria protector provides a new generation technology, eliminating false alarms. Smart solutions simplify installation and commissioning while increasing fire safety. ',
      'Extreme sensor dynamics provide fast and reliable smoke detection and removes nuisance alarms. With AutroGuard it is possible to cover even more application areas. This type of operation is configurable to Heat, Optical or Multisensor. ',
      'The pending patent SelfVerify 2.0 technology ensures that the protector is as reliable for its entire lifetime, as when it left the factory – reducing life cycle cost and giving a safer system.'
    ],
    productImage: 'autro-guard.jpg',
    featureList: [
      'Multi Angle / Multi Wavelength',
      'DYFI3D',
      'SelfVerify 2.0 (optional)',
      'Cover Detection (optional)',
      'False alarm immunity',
      'Dual Heat sensing technology',
      'Integrated sounder (optional)',
      'Integrated visual alarm device (VAD) (optional)',
      'Automatic addressing in the base',
      'Integrated short circuit isolator in the base'
    ]
  },
  {
    id: '877e19c6473740b194756844cb524b85',
    model: '116-V-430-S-VADR',
    title: 'AutroGuard',
    link: 'http://product.autronicafire.com/products/fire-and-gas-detection-systems/detectors/multicriteria-protectors/v-430-series/',
    roomRoute: 'surgery',
    facilityRoute: 'hospital',
    pos: { top: 10, left: 41, unit: '%' },
    content: [
      'AutroGuard® V-430 multicriteria protector provides a new generation technology, eliminating false alarms. Smart solutions simplify installation and commissioning while increasing fire safety. ',
      'Extreme sensor dynamics provide fast and reliable smoke detection and removes nuisance alarms. With AutroGuard it is possible to cover even more application areas. This type of operation is configurable to Heat, Optical or Multisensor. ',
      'The pending patent SelfVerify 2.0 technology ensures that the protector is as reliable for its entire lifetime, as when it left the factory – reducing life cycle cost and giving a safer system.'
    ],
    productImage: 'autro-guard.jpg',
    featureList: [
      'Multi Angle / Multi Wavelength',
      'DYFI3D',
      'SelfVerify 2.0 (optional)',
      'Cover Detection (optional)',
      'False alarm immunity',
      'Dual Heat sensing technology',
      'Integrated sounder (optional)',
      'Integrated visual alarm device (VAD) (optional)',
      'Automatic addressing in the base',
      'Integrated short circuit isolator in the base'
    ]
  },
  {
    id: '6ebd95b3f99643ceba77065b0c9cfaf7',
    model: '116-V-430-S-VADR',
    title: 'AutroGuard',
    link: 'http://product.autronicafire.com/products/fire-and-gas-detection-systems/detectors/multicriteria-protectors/v-430-series/',
    roomRoute: 'lab',
    facilityRoute: 'hospital',
    pos: { top: 20, left: 72, unit: '%' },
    content: [
      'AutroGuard® V-430 multicriteria protector provides a new generation technology, eliminating false alarms. Smart solutions simplify installation and commissioning while increasing fire safety. ',
      'Extreme sensor dynamics provide fast and reliable smoke detection and removes nuisance alarms. With AutroGuard it is possible to cover even more application areas. This type of operation is configurable to Heat, Optical or Multisensor. ',
      'The pending patent SelfVerify 2.0 technology ensures that the protector is as reliable for its entire lifetime, as when it left the factory – reducing life cycle cost and giving a safer system.'
    ],
    productImage: 'autro-guard.jpg',
    featureList: [
      'Multi Angle / Multi Wavelength',
      'DYFI3D',
      'SelfVerify 2.0 (optional)',
      'Cover Detection (optional)',
      'False alarm immunity',
      'Dual Heat sensing technology',
      'Integrated sounder (optional)',
      'Integrated visual alarm device (VAD) (optional)',
      'Automatic addressing in the base',
      'Integrated short circuit isolator in the base'
    ]
  },
  {
    id: '67b2005d91d94026962961d7d2129cdb',
    model: '116-V-430-S-VADR',
    title: 'AutroGuard',
    link: 'http://product.autronicafire.com/products/fire-and-gas-detection-systems/detectors/multicriteria-protectors/v-430-series/',
    roomRoute: 'patient-room',
    facilityRoute: 'hospital',
    pos: { top: 8, left: 38, unit: '%' },
    content: [
      'AutroGuard® V-430 multicriteria protector provides a new generation technology, eliminating false alarms. Smart solutions simplify installation and commissioning while increasing fire safety. ',
      'Extreme sensor dynamics provide fast and reliable smoke detection and removes nuisance alarms. With AutroGuard it is possible to cover even more application areas. This type of operation is configurable to Heat, Optical or Multisensor. ',
      'The pending patent SelfVerify 2.0 technology ensures that the protector is as reliable for its entire lifetime, as when it left the factory – reducing life cycle cost and giving a safer system.'
    ],
    productImage: 'autro-guard.jpg',
    featureList: [
      'Multi Angle / Multi Wavelength',
      'DYFI3D',
      'SelfVerify 2.0 (optional)',
      'Cover Detection (optional)',
      'False alarm immunity',
      'Dual Heat sensing technology',
      'Integrated sounder (optional)',
      'Integrated visual alarm device (VAD) (optional)',
      'Automatic addressing in the base',
      'Integrated short circuit isolator in the base'
    ]
  },
  {
    id: '0e6b72003fae46ffbe4f17d30252474f',
    model: '116-V-430-S-VADR',
    title: 'AutroGuard',
    link: 'http://product.autronicafire.com/products/fire-and-gas-detection-systems/detectors/multicriteria-protectors/v-430-series/',
    roomRoute: 'nurses-station',
    facilityRoute: 'hospital',
    pos: { top: 27, left: 13, unit: '%' },
    content: [
      'AutroGuard® V-430 multicriteria protector provides a new generation technology, eliminating false alarms. Smart solutions simplify installation and commissioning while increasing fire safety. ',
      'Extreme sensor dynamics provide fast and reliable smoke detection and removes nuisance alarms. With AutroGuard it is possible to cover even more application areas. This type of operation is configurable to Heat, Optical or Multisensor. ',
      'The pending patent SelfVerify 2.0 technology ensures that the protector is as reliable for its entire lifetime, as when it left the factory – reducing life cycle cost and giving a safer system.'
    ],
    productImage: 'autro-guard.jpg',
    featureList: [
      'Multi Angle / Multi Wavelength',
      'DYFI3D',
      'SelfVerify 2.0 (optional)',
      'Cover Detection (optional)',
      'False alarm immunity',
      'Dual Heat sensing technology',
      'Integrated sounder (optional)',
      'Integrated visual alarm device (VAD) (optional)',
      'Automatic addressing in the base',
      'Integrated short circuit isolator in the base'
    ]
  },
  {
    id: 'bb5efc0fa86447089612fce1098722c3',
    model: '116-V-430-S-VADR',
    title: 'AutroGuard',
    link: 'http://product.autronicafire.com/products/fire-and-gas-detection-systems/detectors/multicriteria-protectors/v-430-series/',
    roomRoute: 'technical-control-room',
    facilityRoute: 'hospital',
    pos: { top: 15, left: 46, unit: '%' },
    content: [
      'AutroGuard® V-430 multicriteria protector provides a new generation technology, eliminating false alarms. Smart solutions simplify installation and commissioning while increasing fire safety. ',
      'Extreme sensor dynamics provide fast and reliable smoke detection and removes nuisance alarms. With AutroGuard it is possible to cover even more application areas. This type of operation is configurable to Heat, Optical or Multisensor. ',
      'The pending patent SelfVerify 2.0 technology ensures that the protector is as reliable for its entire lifetime, as when it left the factory – reducing life cycle cost and giving a safer system.'
    ],
    productImage: 'autro-guard.jpg',
    featureList: [
      'Multi Angle / Multi Wavelength',
      'DYFI3D',
      'SelfVerify 2.0 (optional)',
      'Cover Detection (optional)',
      'False alarm immunity',
      'Dual Heat sensing technology',
      'Integrated sounder (optional)',
      'Integrated visual alarm device (VAD) (optional)',
      'Automatic addressing in the base',
      'Integrated short circuit isolator in the base'
    ]
  },
  {
    id: '0ed5c63bbf4d415889b7983217de6df7',
    model: '116-V-430-S-VADR',
    title: 'AutroGuard',
    link: 'http://product.autronicafire.com/products/fire-and-gas-detection-systems/detectors/multicriteria-protectors/v-430-series/',
    roomRoute: 'foyer',
    facilityRoute: 'hospital',
    pos: { top: 75, left: 73, unit: '%' },
    content: [
      'AutroGuard® V-430 multicriteria protector provides a new generation technology, eliminating false alarms. Smart solutions simplify installation and commissioning while increasing fire safety. ',
      'Extreme sensor dynamics provide fast and reliable smoke detection and removes nuisance alarms. With AutroGuard it is possible to cover even more application areas. This type of operation is configurable to Heat, Optical or Multisensor. ',
      'The pending patent SelfVerify 2.0 technology ensures that the protector is as reliable for its entire lifetime, as when it left the factory – reducing life cycle cost and giving a safer system.'
    ],
    productImage: 'autro-guard.jpg',
    featureList: [
      'Multi Angle / Multi Wavelength',
      'DYFI3D',
      'SelfVerify 2.0 (optional)',
      'Cover Detection (optional)',
      'False alarm immunity',
      'Dual Heat sensing technology',
      'Integrated sounder (optional)',
      'Integrated visual alarm device (VAD) (optional)',
      'Automatic addressing in the base',
      'Integrated short circuit isolator in the base'
    ]
  },
  {
    id: '26b49896687e4f92b05abbae34b3006a',
    model: '116-V-430-S-VADR',
    title: 'AutroGuard',
    link: 'http://product.autronicafire.com/products/fire-and-gas-detection-systems/detectors/multicriteria-protectors/v-430-series/',
    roomRoute: 'technical-control-room',
    facilityRoute: 'cruise',
    pos: { top: 15, left: 46, unit: '%' },
    content: [
      'AutroGuard® V-430 multicriteria protector provides a new generation technology, eliminating false alarms. Smart solutions simplify installation and commissioning while increasing fire safety. ',
      'Extreme sensor dynamics provide fast and reliable smoke detection and removes nuisance alarms. With AutroGuard it is possible to cover even more application areas. This type of operation is configurable to Heat, Optical or Multisensor. ',
      'The pending patent SelfVerify 2.0 technology ensures that the protector is as reliable for its entire lifetime, as when it left the factory – reducing life cycle cost and giving a safer system.'
    ],
    productImage: 'autro-guard.jpg',
    featureList: [
      'Multi Angle / Multi Wavelength',
      'DYFI3D',
      'SelfVerify 2.0 (optional)',
      'Cover Detection (optional)',
      'False alarm immunity',
      'Dual Heat sensing technology',
      'Integrated sounder (optional)',
      'Integrated visual alarm device (VAD) (optional)',
      'Automatic addressing in the base',
      'Integrated short circuit isolator in the base'
    ]
  },
  {
    id: 'fdd93de6c585467bbe08c84467746962',
    model: '116-V-430-S-VADR',
    title: 'AutroGuard',
    link: 'http://product.autronicafire.com/products/fire-and-gas-detection-systems/detectors/multicriteria-protectors/v-430-series/',
    roomRoute: 'engine-room',
    facilityRoute: 'cruise',
    pos: { top: 21, left: 68, unit: '%' },
    content: [
      'AutroGuard® V-430 multicriteria protector provides a new generation technology, eliminating false alarms. Smart solutions simplify installation and commissioning while increasing fire safety. ',
      'Extreme sensor dynamics provide fast and reliable smoke detection and removes nuisance alarms. With AutroGuard it is possible to cover even more application areas. This type of operation is configurable to Heat, Optical or Multisensor. ',
      'The pending patent SelfVerify 2.0 technology ensures that the protector is as reliable for its entire lifetime, as when it left the factory – reducing life cycle cost and giving a safer system.'
    ],
    productImage: 'autro-guard.jpg',
    featureList: [
      'Multi Angle / Multi Wavelength',
      'DYFI3D',
      'SelfVerify 2.0 (optional)',
      'Cover Detection (optional)',
      'False alarm immunity',
      'Dual Heat sensing technology',
      'Integrated sounder (optional)',
      'Integrated visual alarm device (VAD) (optional)',
      'Automatic addressing in the base',
      'Integrated short circuit isolator in the base'
    ]
  },
  {
    id: 'ddc2706f009c4bd9af2aa4075e06699a',
    model: '116-V-430-S-VADR',
    title: 'AutroGuard',
    link: 'http://product.autronicafire.com/products/fire-and-gas-detection-systems/detectors/multicriteria-protectors/v-430-series/',
    roomRoute: 'bedroom',
    facilityRoute: 'cruise',
    pos: { top: 13, left: 53, unit: '%' },
    content: [
      'AutroGuard® V-430 multicriteria protector provides a new generation technology, eliminating false alarms. Smart solutions simplify installation and commissioning while increasing fire safety. ',
      'Extreme sensor dynamics provide fast and reliable smoke detection and removes nuisance alarms. With AutroGuard it is possible to cover even more application areas. This type of operation is configurable to Heat, Optical or Multisensor. ',
      'The pending patent SelfVerify 2.0 technology ensures that the protector is as reliable for its entire lifetime, as when it left the factory – reducing life cycle cost and giving a safer system.'
    ],
    productImage: 'autro-guard.jpg',
    featureList: [
      'Multi Angle / Multi Wavelength',
      'DYFI3D',
      'SelfVerify 2.0 (optional)',
      'Cover Detection (optional)',
      'False alarm immunity',
      'Dual Heat sensing technology',
      'Integrated sounder (optional)',
      'Integrated visual alarm device (VAD) (optional)',
      'Automatic addressing in the base',
      'Integrated short circuit isolator in the base'
    ]
  },
  {
    id: '8eb80683c1ac4a758c66e2a5022d0ac6',
    model: '116-V-430-S-VADR',
    title: 'AutroGuard',
    link: 'http://product.autronicafire.com/products/fire-and-gas-detection-systems/detectors/multicriteria-protectors/v-430-series/',
    roomRoute: 'conference-hall',
    facilityRoute: 'cruise',
    pos: { top: 18, left: 52, unit: '%' },
    content: [
      'AutroGuard® V-430 multicriteria protector provides a new generation technology, eliminating false alarms. Smart solutions simplify installation and commissioning while increasing fire safety. ',
      'Extreme sensor dynamics provide fast and reliable smoke detection and removes nuisance alarms. With AutroGuard it is possible to cover even more application areas. This type of operation is configurable to Heat, Optical or Multisensor. ',
      'The pending patent SelfVerify 2.0 technology ensures that the protector is as reliable for its entire lifetime, as when it left the factory – reducing life cycle cost and giving a safer system.'
    ],
    productImage: 'autro-guard.jpg',
    featureList: [
      'Multi Angle / Multi Wavelength',
      'DYFI3D',
      'SelfVerify 2.0 (optional)',
      'Cover Detection (optional)',
      'False alarm immunity',
      'Dual Heat sensing technology',
      'Integrated sounder (optional)',
      'Integrated visual alarm device (VAD) (optional)',
      'Automatic addressing in the base',
      'Integrated short circuit isolator in the base'
    ]
  },
  {
    id: '9700fd0064ba4ff3a2f123ca7e8025cb',
    model: '116-V-430-S-VADR',
    title: 'AutroGuard',
    link: 'http://product.autronicafire.com/products/fire-and-gas-detection-systems/detectors/multicriteria-protectors/v-430-series/',
    roomRoute: 'engine-room',
    facilityRoute: 'lng',
    pos: { top: 23, left: 69, unit: '%' },
    content: [
      'AutroGuard® V-430 multicriteria protector provides a new generation technology, eliminating false alarms. Smart solutions simplify installation and commissioning while increasing fire safety. ',
      'Extreme sensor dynamics provide fast and reliable smoke detection and removes nuisance alarms. With AutroGuard it is possible to cover even more application areas. This type of operation is configurable to Heat, Optical or Multisensor. ',
      'The pending patent SelfVerify 2.0 technology ensures that the protector is as reliable for its entire lifetime, as when it left the factory – reducing life cycle cost and giving a safer system.'
    ],
    productImage: 'autro-guard.jpg',
    featureList: [
      'Multi Angle / Multi Wavelength',
      'DYFI3D',
      'SelfVerify 2.0 (optional)',
      'Cover Detection (optional)',
      'False alarm immunity',
      'Dual Heat sensing technology',
      'Integrated sounder (optional)',
      'Integrated visual alarm device (VAD) (optional)',
      'Automatic addressing in the base',
      'Integrated short circuit isolator in the base'
    ]
  },
  {
    id: '9e111ffca022476ea774990047a7a1eb',
    model: '116-V-430-S-VADR',
    title: 'AutroGuard',
    link: 'http://product.autronicafire.com/products/fire-and-gas-detection-systems/detectors/multicriteria-protectors/v-430-series/',
    roomRoute: 'bedroom',
    facilityRoute: 'lng',
    pos: { top: 14, left: 50, unit: '%' },
    content: [
      'AutroGuard® V-430 multicriteria protector provides a new generation technology, eliminating false alarms. Smart solutions simplify installation and commissioning while increasing fire safety. ',
      'Extreme sensor dynamics provide fast and reliable smoke detection and removes nuisance alarms. With AutroGuard it is possible to cover even more application areas. This type of operation is configurable to Heat, Optical or Multisensor. ',
      'The pending patent SelfVerify 2.0 technology ensures that the protector is as reliable for its entire lifetime, as when it left the factory – reducing life cycle cost and giving a safer system.'
    ],
    productImage: 'autro-guard.jpg',
    featureList: [
      'Multi Angle / Multi Wavelength',
      'DYFI3D',
      'SelfVerify 2.0 (optional)',
      'Cover Detection (optional)',
      'False alarm immunity',
      'Dual Heat sensing technology',
      'Integrated sounder (optional)',
      'Integrated visual alarm device (VAD) (optional)',
      'Automatic addressing in the base',
      'Integrated short circuit isolator in the base'
    ]
  },
  {
    id: 'cdfcc27244164e65aed6c094472e8626',
    model: '116-V-430-S-VADR',
    title: 'AutroGuard',
    link: 'http://product.autronicafire.com/products/fire-and-gas-detection-systems/detectors/multicriteria-protectors/v-430-series/',
    roomRoute: 'reliquefication-plant',
    facilityRoute: 'lng',
    pos: { top: 8, left: 71, unit: '%' },
    content: [
      'AutroGuard® V-430 multicriteria protector provides a new generation technology, eliminating false alarms. Smart solutions simplify installation and commissioning while increasing fire safety. ',
      'Extreme sensor dynamics provide fast and reliable smoke detection and removes nuisance alarms. With AutroGuard it is possible to cover even more application areas. This type of operation is configurable to Heat, Optical or Multisensor. ',
      'The pending patent SelfVerify 2.0 technology ensures that the protector is as reliable for its entire lifetime, as when it left the factory – reducing life cycle cost and giving a safer system.'
    ],
    productImage: 'autro-guard.jpg',
    featureList: [
      'Multi Angle / Multi Wavelength',
      'DYFI3D',
      'SelfVerify 2.0 (optional)',
      'Cover Detection (optional)',
      'False alarm immunity',
      'Dual Heat sensing technology',
      'Integrated sounder (optional)',
      'Integrated visual alarm device (VAD) (optional)',
      'Automatic addressing in the base',
      'Integrated short circuit isolator in the base'
    ]
  },
  {
    id: 'd6bb7512f9c04a53aeb2c3188239d9f0',
    model: '116-V-430-S-VADR',
    title: 'AutroGuard',
    link: 'http://product.autronicafire.com/products/fire-and-gas-detection-systems/detectors/multicriteria-protectors/v-430-series/',
    roomRoute: 'nacelle',
    facilityRoute: 'wind-farm',
    pos: { top: 28, left: 72, unit: '%' },
    content: [
      'AutroGuard® V-430 multicriteria protector provides a new generation technology, eliminating false alarms. Smart solutions simplify installation and commissioning while increasing fire safety. ',
      'Extreme sensor dynamics provide fast and reliable smoke detection and removes nuisance alarms. With AutroGuard it is possible to cover even more application areas. This type of operation is configurable to Heat, Optical or Multisensor. ',
      'The pending patent SelfVerify 2.0 technology ensures that the protector is as reliable for its entire lifetime, as when it left the factory – reducing life cycle cost and giving a safer system.'
    ],
    productImage: 'autro-guard.jpg',
    featureList: [
      'Multi Angle / Multi Wavelength',
      'DYFI3D',
      'SelfVerify 2.0 (optional)',
      'Cover Detection (optional)',
      'False alarm immunity',
      'Dual Heat sensing technology',
      'Integrated sounder (optional)',
      'Integrated visual alarm device (VAD) (optional)',
      'Automatic addressing in the base',
      'Integrated short circuit isolator in the base'
    ]
  },
  {
    id: '2a79fca6d23e44a8b897682619d38e7b',
    model: '116-V-430-S-VADR',
    title: 'AutroGuard',
    link: 'http://product.autronicafire.com/products/fire-and-gas-detection-systems/detectors/multicriteria-protectors/v-430-series/',
    roomRoute: 'tower',
    facilityRoute: 'wind-farm',
    pos: { top: 34, left: 49, unit: '%' },
    content: [
      'AutroGuard® V-430 multicriteria protector provides a new generation technology, eliminating false alarms. Smart solutions simplify installation and commissioning while increasing fire safety. ',
      'Extreme sensor dynamics provide fast and reliable smoke detection and removes nuisance alarms. With AutroGuard it is possible to cover even more application areas. This type of operation is configurable to Heat, Optical or Multisensor. ',
      'The pending patent SelfVerify 2.0 technology ensures that the protector is as reliable for its entire lifetime, as when it left the factory – reducing life cycle cost and giving a safer system.'
    ],
    productImage: 'autro-guard.jpg',
    featureList: [
      'Multi Angle / Multi Wavelength',
      'DYFI3D',
      'SelfVerify 2.0 (optional)',
      'Cover Detection (optional)',
      'False alarm immunity',
      'Dual Heat sensing technology',
      'Integrated sounder (optional)',
      'Integrated visual alarm device (VAD) (optional)',
      'Automatic addressing in the base',
      'Integrated short circuit isolator in the base'
    ]
  },
  {
    id: '8d417cfb572a43f3814a88ea82305ba0',
    model: '116-V-430-S-VADR',
    title: 'AutroGuard',
    link: 'http://product.autronicafire.com/products/fire-and-gas-detection-systems/detectors/multicriteria-protectors/v-430-series/',
    roomRoute: 'emergency-power-supply-room',
    facilityRoute: 'e-house',
    pos: { top: 15, left: 58, unit: '%' },
    content: [
      'AutroGuard® V-430 multicriteria protector provides a new generation technology, eliminating false alarms. Smart solutions simplify installation and commissioning while increasing fire safety. ',
      'Extreme sensor dynamics provide fast and reliable smoke detection and removes nuisance alarms. With AutroGuard it is possible to cover even more application areas. This type of operation is configurable to Heat, Optical or Multisensor. ',
      'The pending patent SelfVerify 2.0 technology ensures that the protector is as reliable for its entire lifetime, as when it left the factory – reducing life cycle cost and giving a safer system.'
    ],
    productImage: 'autro-guard.jpg',
    featureList: [
      'Multi Angle / Multi Wavelength',
      'DYFI3D',
      'SelfVerify 2.0 (optional)',
      'Cover Detection (optional)',
      'False alarm immunity',
      'Dual Heat sensing technology',
      'Integrated sounder (optional)',
      'Integrated visual alarm device (VAD) (optional)',
      'Automatic addressing in the base',
      'Integrated short circuit isolator in the base'
    ]
  },
  {
    id: '7406418bb24348b6b33bdf43cfc40895',
    model: '116-V-430-S-VADR',
    title: 'AutroGuard',
    link: 'http://product.autronicafire.com/products/fire-and-gas-detection-systems/detectors/multicriteria-protectors/v-430-series/',
    roomRoute: 'transformer-chiller-generator',
    facilityRoute: 'e-house',
    pos: { top: 11, left: 53, unit: '%' },
    content: [
      'AutroGuard® V-430 multicriteria protector provides a new generation technology, eliminating false alarms. Smart solutions simplify installation and commissioning while increasing fire safety. ',
      'Extreme sensor dynamics provide fast and reliable smoke detection and removes nuisance alarms. With AutroGuard it is possible to cover even more application areas. This type of operation is configurable to Heat, Optical or Multisensor. ',
      'The pending patent SelfVerify 2.0 technology ensures that the protector is as reliable for its entire lifetime, as when it left the factory – reducing life cycle cost and giving a safer system.'
    ],
    productImage: 'autro-guard.jpg',
    featureList: [
      'Multi Angle / Multi Wavelength',
      'DYFI3D',
      'SelfVerify 2.0 (optional)',
      'Cover Detection (optional)',
      'False alarm immunity',
      'Dual Heat sensing technology',
      'Integrated sounder (optional)',
      'Integrated visual alarm device (VAD) (optional)',
      'Automatic addressing in the base',
      'Integrated short circuit isolator in the base'
    ]
  },
  {
    id: '193b259881e44a3193170c015c0b897b',
    model: '116-V.430-S-VADR',
    title: 'AutroGuard',
    link: 'http://product.autronicafire.com/products/fire-and-gas-detection-systems/detectors/multicriteria-protectors/v-430-series/',
    roomRoute: 'hull',
    facilityRoute: 'lng',
    pos: { top: 42, left: 2, unit: '%' },
    content: [],
    productImage: 'autro-guard.jpg',
    featureList: []
  },
  {
    id: '8e4fc1032a0e4bb2958cc4b76e56ba3b',
    model: 'BBQ-230',
    title: 'Sounder',
    link: 'http://product.autronicafire.com/products/fire-and-gas-detection-systems/alarm-units/combined-sound-light/bbq-230/',
    roomRoute: 'data-hall',
    facilityRoute: 'data-center',
    pos: { top: 31, left: 72, unit: '%' },
    content: [
      'BBQ-230 is an addressable sounder/VAD that is connected to the detection loop. The device provides different advanced sound patterns according to configuration. All devices within the same loop will have synchronized sound outputs, so two sounders located near each other will be perceived as one.'
    ],
    productImage: 'sounder.jpg',
    featureList: [
      'Sounder/Visual Alarm Device (VAD) intended for indoor use',
      'Connects directly to the detection loop - no extra wiring needed',
      'Automatic addressing'
    ]
  },
  {
    id: '4c28361d6d0040aa84fba6c15e7abebc',
    model: 'BBQ-230',
    title: 'Sounder',
    link: 'http://product.autronicafire.com/products/fire-and-gas-detection-systems/alarm-units/combined-sound-light/bbq-230/',
    roomRoute: 'electrical-switching-room',
    facilityRoute: 'data-center',
    pos: { top: 42, left: 69, unit: '%' },
    content: [
      'BBQ-230 is an addressable sounder/VAD that is connected to the detection loop. The device provides different advanced sound patterns according to configuration. All devices within the same loop will have synchronized sound outputs, so two sounders located near each other will be perceived as one.'
    ],
    productImage: 'sounder.jpg',
    featureList: [
      'Sounder/Visual Alarm Device (VAD) intended for indoor use',
      'Connects directly to the detection loop - no extra wiring needed',
      'Automatic addressing'
    ]
  },
  {
    id: '3af891f1cef044649800c316ed1edcb0',
    model: 'BBQ-230',
    title: 'Sounder',
    link: 'http://product.autronicafire.com/products/fire-and-gas-detection-systems/alarm-units/combined-sound-light/bbq-230/',
    roomRoute: 'data-hall',
    facilityRoute: 'e-house',
    pos: { top: 35, left: 70, unit: '%' },
    content: [
      'BBQ-230 is an addressable sounder/VAD that is connected to the detection loop. The device provides different advanced sound patterns according to configuration. All devices within the same loop will have synchronized sound outputs, so two sounders located near each other will be perceived as one.'
    ],
    productImage: 'sounder.jpg',
    featureList: [
      'Sounder/Visual Alarm Device (VAD) intended for indoor use',
      'Connects directly to the detection loop - no extra wiring needed',
      'Automatic addressing'
    ]
  },
  {
    id: 'c5be3622bb834c0da99b73411bd57357',
    model: 'BBQ-230',
    title: 'Sounder',
    link: 'http://product.autronicafire.com/products/fire-and-gas-detection-systems/alarm-units/combined-sound-light/bbq-230/',
    roomRoute: 'electrical-switching-room',
    facilityRoute: 'e-house',
    pos: { top: 35, left: 67, unit: '%' },
    content: [
      'BBQ-230 is an addressable sounder/VAD that is connected to the detection loop. The device provides different advanced sound patterns according to configuration. All devices within the same loop will have synchronized sound outputs, so two sounders located near each other will be perceived as one.'
    ],
    productImage: 'sounder.jpg',
    featureList: [
      'Sounder/Visual Alarm Device (VAD) intended for indoor use',
      'Connects directly to the detection loop - no extra wiring needed',
      'Automatic addressing'
    ]
  },
  {
    id: 'f9e8b61a1d6f41b7bfc74fe893121afc',
    model: 'BV-110',
    title: 'Information panel',
    link: 'http://product.autronicafire.com/products/fire-and-gas-detection-systems/autrosafe-4/bv-110/',
    roomRoute: 'nurses-station',
    facilityRoute: 'hospital',
    pos: { top: 50, left: 70, unit: '%' },
    content: [
      'The repeater panel serves as either a fire brigade panel or an information panel, depending on the settings. The panel communicate with other system units on Ethernet.'
    ],
    productImage: 'BV_110.jpg',
    featureList: []
  },
  {
    id: 'beefb0ef59c54af5b23be4881e6efd95',
    model: 'BV110',
    title: 'Information panel',
    link: 'http://product.autronicafire.com/products/fire-and-gas-detection-systems/autrosafe-4/bv-110/',
    roomRoute: 'surgery',
    facilityRoute: 'hospital',
    pos: { top: 48, left: 36, unit: '%' },
    content: [
      'The repeater panel serves as either a fire brigade panel or an information panel, depending on the settings. The panel communicate with other system units on Ethernet.'
    ],
    productImage: 'BV_110.jpg',
    featureList: []
  },
  {
    id: 'eaf8f2fc0cec44cbbcd2b3f726c2f5b0',
    model: 'HC-200',
    title: 'AutroPoint',
    link: 'http://product.autronicafire.com/products/omicron-special-detection/point-gas-detection-system-ogs-21/gas-sensors-and-accessories/autropoint-maritime-gas-detector/',
    roomRoute: 'engine-room',
    facilityRoute: 'cruise',
    pos: { top: 10, left: 81, unit: '%' },
    content: [],
    productImage: 'atro-point.jpg',
    featureList: []
  },
  {
    id: 'a0269486be464fc182aa2a9eb3b92623',
    model: 'HC-200',
    title: 'AutroPoint',
    link: 'http://product.autronicafire.com/products/omicron-special-detection/point-gas-detection-system-ogs-21/gas-sensors-and-accessories/autropoint-maritime-gas-detector/',
    roomRoute: 'engine-room',
    facilityRoute: 'lng',
    pos: { top: 9, left: 82, unit: '%' },
    content: [],
    productImage: 'atro-point.jpg',
    featureList: []
  },
  {
    id: 'a376c8c7589541a6a405d8f5ef0d4539',
    model: 'HC-200',
    title: 'AutroPoint',
    link: 'http://product.autronicafire.com/products/omicron-special-detection/point-gas-detection-system-ogs-21/gas-sensors-and-accessories/autropoint-maritime-gas-detector/',
    roomRoute: 'reliquefication-plant',
    facilityRoute: 'lng',
    pos: { top: 27, left: 31, unit: '%' },
    content: [],
    productImage: 'atro-point.jpg',
    featureList: []
  },
  {
    id: '7b119aeeb54644e395bcbc25554f68cf',
    model: 'Pipe*',
    title: 'Gas-Sampling',
    link: 'http://product.autronicafire.com/products/omicron-special-detection/gas-sampling-systems-ogs-31-ogs-311/',
    roomRoute: 'hull',
    facilityRoute: 'lng',
    pos: { top: 98, left: 8, unit: '%' },
    content: [],
    productImage: 'ogs-3.1-ogs-3.2.png',
    featureList: []
  }
];
